// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/SF-Pro-Text-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/SF-Pro-Text-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/SF-Pro-Text-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SF-PRO';
    font-display: swap;
    src: local('SF-PRO'), local('SF-PRO-Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 540;
    font-style: normal;
}

@font-face {
    font-family: 'SF-PRO';
    font-display: swap;
    src: local('SF-PRO'), local('SF-PRO-Semibold'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 760;
    font-style: normal;
}

@font-face {
    font-family: 'SF-PRO';
    font-display: swap;
    src: local('SF-PRO'), local('SF-PRO-Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: 410;
    font-style: normal;
}

input::-webkit-calendar-picker-indicator {
    display: none;
}

input[type='text'] {
    -webkit-appearance: textfield;
    appearance: textfield;
}

#root {
    --delab_background_card: #1f1f2a;
    --delab_background_card_hover: rgb(45, 45, 45);

    --delab_radius_1: 40px;
    --delab_radius_2: 27px;
    --delab_radius_3: 18px;
    --delab_radius_4: 12px;

    --delab_font_size_1: 40px;
    --delab_font_size_2: 35px;

    --accent: #fff;

    --text_primary: #fff;
    --header_text: #fff;
    --header_text_alternate: #fff;
    --header_tab_active_text: #fff;

    --button_tertiary_foreground: #fff;
    --cell_button_foreground: #fff;
    --counter_primary_background: #fff;
    --control_foreground: #fff;
    --button_secondary_foreground: #fff;
    --button_primary_background: #fff;
    --button_outline_foreground: #fff;
    --button_outline_border: #fff;
    --button_muted_foreground: #fff;

    --button_primary_foreground: #000;

    --field_background: rgb(0, 0, 0);

    --background_content: var(--delab_background_card);

    --content_tint_background: #000;

    position: relative;
}

input {
    outline: none;
}

#root::before {
    content: '';
    position: fixed;
    width: 70%;
    height: 80%;
    border-radius: 600px;
    background: rgba(0, 122, 255, 0.25);
    filter: blur(110px);
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
}

* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    /* min-height: -webkit-fill-available; */
}

input,
input:before,
input:after {
    -webkit-user-select: initial !important;
    -khtml-user-select: initial !important;
    -moz-user-select: initial !important;
    -ms-user-select: initial !important;
    user-select: initial !important;
}

body {
    font-family: 'SF-PRO';
    color: rgb(var(--placeholder-primary));
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch !important;
    /* padding-bottom: env(safe-area-inset-bottom, 20px); */
    /* height: 100vh; */
}

html {
    overflow: hidden;
}

a,
a * a div,
a:hover,
a:hover * a:hover div {
    text-decoration: none !important;
}

::-webkit-scrollbar {
    display: none;
}

::-webkit-scrollbar-track {
    display: none;
}
::-webkit-scrollbar-thumb {
    display: none;
}

.rGEH4vI_BZ0SvFXEf6Ea {
    z-index: 119999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wGAAgH;IAChH,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,0GAAoH;IACpH,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yGAAkH;IAClH,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,8CAA8C;;IAE9C,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;;IAEtB,yBAAyB;IACzB,yBAAyB;;IAEzB,cAAc;;IAEd,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;;IAE9B,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;IAC1B,mCAAmC;IACnC,iCAAiC;IACjC,iCAAiC;IACjC,6BAA6B;IAC7B,+BAA+B;;IAE/B,iCAAiC;;IAEjC,gCAAgC;;IAEhC,kDAAkD;;IAElD,+BAA+B;;IAE/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,mCAAmC;IACnC,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;;;IAGI,uCAAuC;IACvC,sCAAsC;IACtC,oCAAoC;IACpC,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,4CAA4C;IAC5C,uDAAuD;IACvD,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n@font-face {\n    font-family: 'SF-PRO';\n    font-display: swap;\n    src: local('SF-PRO'), local('SF-PRO-Medium'), url('../assets/fonts/SF-Pro-Text-Medium.woff2') format('truetype');\n    font-weight: 540;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'SF-PRO';\n    font-display: swap;\n    src: local('SF-PRO'), local('SF-PRO-Semibold'), url('../assets/fonts/SF-Pro-Text-Semibold.woff2') format('truetype');\n    font-weight: 760;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'SF-PRO';\n    font-display: swap;\n    src: local('SF-PRO'), local('SF-PRO-Regular'), url('../assets/fonts/SF-Pro-Text-Regular.woff2') format('truetype');\n    font-weight: 410;\n    font-style: normal;\n}\n\ninput::-webkit-calendar-picker-indicator {\n    display: none;\n}\n\ninput[type='text'] {\n    -webkit-appearance: textfield;\n    appearance: textfield;\n}\n\n#root {\n    --delab_background_card: #1f1f2a;\n    --delab_background_card_hover: rgb(45, 45, 45);\n\n    --delab_radius_1: 40px;\n    --delab_radius_2: 27px;\n    --delab_radius_3: 18px;\n    --delab_radius_4: 12px;\n\n    --delab_font_size_1: 40px;\n    --delab_font_size_2: 35px;\n\n    --accent: #fff;\n\n    --text_primary: #fff;\n    --header_text: #fff;\n    --header_text_alternate: #fff;\n    --header_tab_active_text: #fff;\n\n    --button_tertiary_foreground: #fff;\n    --cell_button_foreground: #fff;\n    --counter_primary_background: #fff;\n    --control_foreground: #fff;\n    --button_secondary_foreground: #fff;\n    --button_primary_background: #fff;\n    --button_outline_foreground: #fff;\n    --button_outline_border: #fff;\n    --button_muted_foreground: #fff;\n\n    --button_primary_foreground: #000;\n\n    --field_background: rgb(0, 0, 0);\n\n    --background_content: var(--delab_background_card);\n\n    --content_tint_background: #000;\n\n    position: relative;\n}\n\ninput {\n    outline: none;\n}\n\n#root::before {\n    content: '';\n    position: fixed;\n    width: 70%;\n    height: 80%;\n    border-radius: 600px;\n    background: rgba(0, 122, 255, 0.25);\n    filter: blur(110px);\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: -1;\n}\n\n* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    /* min-height: -webkit-fill-available; */\n}\n\ninput,\ninput:before,\ninput:after {\n    -webkit-user-select: initial !important;\n    -khtml-user-select: initial !important;\n    -moz-user-select: initial !important;\n    -ms-user-select: initial !important;\n    user-select: initial !important;\n}\n\nbody {\n    font-family: 'SF-PRO';\n    color: rgb(var(--placeholder-primary));\n    overflow-x: hidden;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch !important;\n    /* padding-bottom: env(safe-area-inset-bottom, 20px); */\n    /* height: 100vh; */\n}\n\nhtml {\n    overflow: hidden;\n}\n\na,\na * a div,\na:hover,\na:hover * a:hover div {\n    text-decoration: none !important;\n}\n\n::-webkit-scrollbar {\n    display: none;\n}\n\n::-webkit-scrollbar-track {\n    display: none;\n}\n::-webkit-scrollbar-thumb {\n    display: none;\n}\n\n.rGEH4vI_BZ0SvFXEf6Ea {\n    z-index: 119999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
